const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppointementList/AppointmentMenu.tsx';
import { Divider, IconButton, MenuItem } from '@mui/material';
import { useIntl } from 'react-intl';
import textMap from './translations';
import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import { theme } from 'App/utils/clientSetupManager';
import _ from 'lodash';
import { actionCancelAppointment } from 'App/actions/appointment';
import { css } from '@emotion/css';
import { useDispatch, useSelector } from 'react-redux';
import {
    appointmentIsWithin24Hours,
    convertStructuredAppointmentToAppointmentObject,
} from '@cistec/common_web/utils/kisim';
import { useHistory } from 'react-router';
import { AddAppointmentToCalendar } from '../AddAppointmentToCalendar/AddAppointmentToCalendar';
import { goToAppointmentReschedule } from 'App/utils/history';
import { useFeatureFlags } from 'App/store/featureFlags';
import { selectEmailFromRegisterWorkItem } from 'App/store/login';
import { useAllTreatmentResons } from 'App/store/schedulingPlan';

interface IAppointmentMenuProps {
    appointment: StructuredAppointment;
}

const cssIconBtn = css`
    padding: 0;
`;

export const AppointmentMenu = (props: IAppointmentMenuProps) => {
    const { appointment } = props;
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<any>();
    const history = useHistory();

    const { data: bookableAppointmentKinds } = useAllTreatmentResons();

    const isLinkededPatient = !useSelector(selectEmailFromRegisterWorkItem);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const { data: featureFlags } = useFeatureFlags();
    const showCancelButtonForNotLinkedPatient = featureFlags.appointment.IAMCancelAppointment;

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getMenuItems = (appointment: StructuredAppointment) => {
        const appointmentObject = convertStructuredAppointmentToAppointmentObject(appointment, formatMessage);
        const isLessThan24Hours = appointmentIsWithin24Hours(appointment);

        const manipulateAppointmentActions = _.compact([
            !isLessThan24Hours && bookableAppointmentKinds.includes(appointmentObject.kind) ? (
                <MenuItem
                    style={{ paddingLeft: '8px' }}
                    key={`reschedule-${appointment.TERMNR}`}
                    onClick={() => {
                        goToAppointmentReschedule(history, appointment.TERMNR);
                    }}
                >
                    {formatMessage(textMap.rescheduleAppointment)}
                </MenuItem>
            ) : null,
            (isLinkededPatient || showCancelButtonForNotLinkedPatient) &&
            !isLessThan24Hours &&
            featureFlags.appointment.cancelAppointment ? (
                <MenuItem
                    style={{ paddingLeft: '8px' }}
                    key={`cancel-${appointment.TERMNR}`}
                    onClick={() => {
                        dispatch(actionCancelAppointment(appointment));
                    }}
                >
                    {formatMessage(textMap.cancelAppointment)}
                </MenuItem>
            ) : null,
        ]);

        return _.compact([
            ...manipulateAppointmentActions,
            manipulateAppointmentActions.length > 0 && <Divider key={'D' + appointment.TERMNR} />,
            <AddAppointmentToCalendar
                key={'E' + appointment.TERMNR}
                appointmentObject={appointmentObject}
                inputProps={{
                    className: css`
                        border: none;
                        font-size: ${theme.typography.h5.fontSize};
                        color: inherit;
                    `,
                }}
            />,
        ]);
    };

    const getMenuButton = () => (
        <IconButton
            aria-label="settings"
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            className={cssIconBtn}
        >
            <MoreVertIcon style={{ color: `${theme.palette.primary.main}` }} />
        </IconButton>
    );

    const getMenu = () => (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
                list: {
                    'aria-labelledby': 'basic-button',
                },
            }}
        >
            {getMenuItems(appointment)}
        </Menu>
    );

    return (
        <>
            {getMenuButton()}
            {getMenu()}
        </>
    );
};
